import React from 'react';
import { NOC_MODE_TRENDS } from '@utils/constants';
import { tid } from '@utils/test';
import Summary from './SummaryV2';
import Tabs from '../../Tabs';
import Title from './Title';
import { TopPanelWrapper } from '../../styled';

interface IProps {
  setShowFilterPanel: any;
  nocMode: any;
  currentShareId: string;
  pageType: number;
  history: any;
  isSharing: boolean;
  pageKeyForSaveService: string;
  setView(view: string): string;
}
// eslint-disable-next-line react/display-name
export default (props: IProps) => {
  const {
    setShowFilterPanel,
    nocMode,
    setView,
    currentShareId,
    history,
    pageType,
    isSharing,
    pageKeyForSaveService,
  } = props;

  return (
    <TopPanelWrapper mode={nocMode} {...tid('controls')}>
      <Tabs currentShareId={currentShareId} history={history} pageType={pageType} />
      {nocMode === NOC_MODE_TRENDS ? <Title setShowFilterPanel={setShowFilterPanel} /> : null}
      <Summary
        setView={setView}
        setShowFilterPanel={setShowFilterPanel}
        pageType={pageType}
        isSharing={isSharing}
        currentShareId={currentShareId}
        pageKeyForSaveService={pageKeyForSaveService}
      />
    </TopPanelWrapper>
  );
};
